<h2>Grid Demo</h2>

<h3>Server Grid</h3>
<app-server-grid [configuration]="serverGridConfiguration"
                 [(request)]="serverRequest"
                 [(selection)]="serverGridSelection"
                 [filterTemplate]="serverFilterTemplate"
                 [actionTemplate]="actionTemplate"
                 [rowExpandTemplate]="rowExpandTemplate">

  <ng-template #actionTemplate>
    <app-button text="Print To Console"></app-button>
  </ng-template>

  <ng-template #serverFilterTemplate
               let-form>
    <form-factory [formGroup]="form"
                  [model]="chaseIdInput"></form-factory>
  </ng-template>

  <ng-template #rowExpandTemplate let-rowData>
    <pre>JSON: {{ rowData | json }}</pre>
  </ng-template>

</app-server-grid>
<pre>{{ serverGridSelection | json }}</pre>

<h3>Basic Grid</h3>
<app-basic-grid [configuration]="basicGridConfiguration"
                [data]="basicGridData"
                [(selection)]="basicGridSelection"
                [actionTemplate]="actionTemplate"
                [filterTemplate]="filterTemplate"
                [rowExpandTemplate]="rowExpandTemplate">

  <ng-template #actionTemplate
               let-i="index"
               let-rowData
               let-popover="actionPopover">
    <div class="action-template-container">
      <pre>Index: {{ i }}</pre>
      <pre>JSON: {{ rowData | json }}</pre>
      <app-button text="Print To Console"
                  (onClick)="printActionArgumentsToConsole(i, rowData)"></app-button>
      <app-button text="Same Thing"
                  (onClick)="printActionArgumentsToConsole(i, rowData)"></app-button>
      <app-button text="Just another button with the same thing"
                  (onClick)="printActionArgumentsToConsole(i, rowData); popover.hide();"></app-button>
    </div>
  </ng-template>

  <ng-template #filterTemplate>
    This is the filter template.
  </ng-template>

  <ng-template #rowExpandTemplate let-rowData>
    <pre>JSON: {{ rowData | json }}</pre>
  </ng-template>

</app-basic-grid>
<pre>{{ basicGridSelection | json }}</pre>

<h3>Obsolete Grid</h3>
<app-obsolete-grid [gridConfiguration]="basicGridConfiguration"
                   [rowData]="basicGridData"></app-obsolete-grid>